import { useTokenizedApi } from '../useTokenizedApi';
import { useLocale } from '../intl/useLocale';

/** @category Relationships */
export function useContactInitialsFromName(name = '') {
  const tokenizedApi = useTokenizedApi();
  const locale = useLocale();

  return tokenizedApi?.relationships.contactInitialsFromName(name, locale);
}
